import { db } from '@app/icare/client/db'
import { localResultQueryOptions } from '@app/icare/client/db/client/localQueryOptions'
import type { PatientIdType } from '@app/icare/entities/patient/schema/Patient'
import type { PatientFindingGroup, PatientFindingView } from '@app/icare/entities/patientFinding/schema/PatientFinding'

export function patientFindingsQueryOptions(patientId: PatientIdType) {
  return localResultQueryOptions({
    meta: { scope: { patientId: String(patientId), tags: ['patient-findings'] } },
    placeholderData: [] as never,
    query: db.selectFrom('patientFindingsView').selectAll().where('patientId', '=', patientId),
  })
}

export const selectByGroup =
  (group: PatientFindingGroup) =>
  (findings: PatientFindingView[] = []) => {
    return findings.filter(f => f.findingGroup === group)
  }

export const selectByGroups =
  (groups: PatientFindingGroup[]) =>
  (findings: PatientFindingView[] = []) => {
    return findings.filter(f => groups.includes(f.findingGroup))
  }

export const selectByGroupOnly =
  (group: PatientFindingGroup) =>
  (findings: PatientFindingView[] = []) => {
    return findings.filter(f => f.findingGroup === group && !f.relationId)
  }

export const selectByGroupAndGroupByRelationId =
  (group: PatientFindingGroup) =>
  (findings: PatientFindingView[] = []) => {
    return findings
      .filter(f => f.findingGroup === group)
      .reduce(
        (acc, finding) => {
          const key = finding.relationId ?? 'global'
          if (!acc[key]) {
            acc[key] = []
          }
          acc[key].push(finding)
          return acc
        },
        {} as Record<string | 'global', PatientFindingView[]>,
      )
  }

export const selectByRelationId =
  (relationId: string) =>
  (findings: PatientFindingView[] = []) => {
    return findings.filter(f => f.relationId === relationId)
  }

export const selectByFindingId =
  (findingId: string) =>
  (findings: PatientFindingView[] = []) => {
    return findings.filter(f => f.findingId === findingId)
  }
export const selectByFindingIds =
  (findingIds: string[]) =>
  (findings: PatientFindingView[] = []) => {
    return findings.filter(f => findingIds.includes(f.findingId))
  }
